import type { FC } from 'react'
import type { Content } from '@prismicio/client'
import type { SliceComponentProps } from '@prismicio/react'
import LogosSlider from '../LogosSlider'

export type SubsDetailLogosSliderProps = SliceComponentProps<Content.SubsDetailLogosSliderSlice>

// eslint-disable-next-line react/function-component-definition
const SubsDetailLogosSlider: FC<SubsDetailLogosSliderProps> = ({ slice }) => {
	const { primary, items } = slice

	const logos = (items as { logo_url?: any; logo_alt?: string }[])
		.map((item) => {
			const logoUrl = item.logo_url?.url
			if (!logoUrl) return null
			return { url: logoUrl, alt: item.logo_alt || '' }
		})
		.filter(Boolean) as Array<{ url: string; alt: string }>

	return (
		<LogosSlider
			sliceType={slice.slice_type}
			sliceVariation={slice.variation}
			color={primary.slider_color || '#000000'}
			logoColor={(primary as any).logo_color}
			speed={2}
			heightDesktop={primary.slider_height_desktop || 100}
			heightMobile={primary.slider_height_mobile || 80}
			logos={logos}
		/>
	)
}

export default SubsDetailLogosSlider
